import api from '../../api'

const {
  getDataset,
  addItem,
  removeItem,
  editItem,
  createDataset,
  addMedia,
  removeMedia,
  deleteDataset,
  saveDataset,
  fetchAllDataFormats,
  fetchAllClassifications,
  fetchAllMediaTypes,
  fetchAllResourceTypes,
  fetchAllPIs,
  fetchAllDatasets
} = api

const state = {
  allDataFormats: null,
  allClassifications: null,
  allMediaTypes: null,
  allResourceTypes: null,
  allPIs: null,
  allDatasets: []
}

export const mutations = {
  setAllDatasets (state, payload) {
    state.allDatasets = payload
  },
  setAllDataFormats (state, payload) {
    state.allDataFormats = payload
  },
  setAllClassifications (state, payload) {
    state.allClassifications = payload
  },
  setAllMediaTypes (state, payload) {
    state.allMediaTypes = payload
  },
  setAllResourceTypes (state, payload) {
    state.allResourceTypes = payload
  },
  setAllPIs (state, payload) {
    state.allPIs = payload
  }
}

export const actions = {
  getDatasetAction ({ commit, getters }, key) {
    return getDataset(key)
      .then(response => {
        commit('setDataset', response.data.dataset)
        commit('setDatasetEdits', response.data.dataset)
      })
      .catch(e => {
        commit('logError', e)
      })
  },

  addItemAction ({ commit, getters }, payload) {
    return addItem(getters.getDatasetKey, payload.endpoint, payload.data)
      .then(response => commit('addItemMut', {
        item: response.data.item,
        array: payload.array
      }))
      .catch(e => commit('logError', e))
  },
  removeItemAction ({ commit, getters }, payload) {
    return removeItem(getters.getDatasetKey, payload.endpoint, payload.key)
      .then(response => commit('removeItemMut', {
        key: payload.key,
        array: payload.array
      }))
      .catch(e => commit('logError', e))
  },
  editItemAction ({ commit, getters }, payload) {
    return editItem(getters.getDatasetKey, payload.endpoint, payload.key, payload.data)
      .then((response) => {
        commit('removeItemMut', {
          key: payload.key,
          array: payload.array
        })
        commit('addItemMut', {
          item: response.data.item,
          array: payload.array
        })
      })
      .catch(e => {
        commit('logError', e)
      })
  },
  createDatasetAction ({ commit, getters }, payload) {
    return new Promise((resolve, reject) => {
      createDataset(payload.data)
        .then(response => {
          commit('setDatasetKey', response.data.dataset.dataset_key)
          commit('setDataset', response.data.dataset)
          resolve(response)
        })
        .catch(e => {
          commit('logError', e)
          reject(e)
        })
    })
  },
  removeMediaAction ({ commit, getters }, payload) {
    return removeMedia(getters.getDatasetKey, payload.key)
      .then(response => commit('removeFileMut', {
        key: payload.key,
        array: payload.array
      }))
      .catch(e => commit('logError', e))
  },
  addMediaAction ({ commit, getters }, payload) {
    return addMedia(getters.getDatasetKey, payload.data)
      .then(response => commit('addItemMut', {
        item: response.data.item,
        array: payload.array
      }))
      .catch(e => commit('logError', e))
  },
  addDatasetDataFormatCreate ({ getters, commit }, payload) {
    return addItem(getters.getDatasetKey, 'dataformat', payload.json)
      .catch(e => commit('logError', e))
  },
  addDatasetClassificationCreate ({ getters, commit }, payload) {
    return addItem(getters.getDatasetKey, 'classification', payload.json)
      .catch(e => commit('logError', e))
  },
  deleteDatasetAction ({ getters, commit }) {
    return deleteDataset(getters.getDatasetKey)
      .catch(error => {
        commit('logError', error)
      })
  },
  saveDatasetAction ({ getters, commit, dispatch }, payload) {
    return saveDataset(getters.getDatasetKey, payload.data)
      .then(() => {
        dispatch('getDatasetAction', getters.getDatasetKey)
      })
      .catch(error => {
        commit('logError', error)
      })
  },
  fetchAllDatasetsAction ({ state, commit }) {
    if (!state.allDatasets.length > 0) {
      fetchAllDatasets()
        .then(response => {
          commit('setAllDatasets', response.data.dataset)
        })
        .catch(e => {
          commit('logError', e)
        })
    }
  },
  fetchAllDataFormatsAction ({ state, commit }) {
    if (!state.allDataFormats) {
      fetchAllDataFormats()
        .then(response => {
          commit('setAllDataFormats', response.data.data_format)
        })
        .catch(e => {
          commit('logError', e)
        })
    }
  },
  fetchAllClassificationsAction ({ state, commit }) {
    if (!state.allClassifications) {
      fetchAllClassifications()
        .then(response => {
          commit('setAllClassifications', response.data.classification)
        })
        .catch(e => {
          commit('logError', e)
        })
    }
  },
  fetchAllMediaTypesAction ({ state, commit }) {
    if (!state.allMediaTypes) {
      fetchAllMediaTypes()
        .then(response => {
          commit('setAllMediaTypes', response.data.media_type)
        })
        .catch(e => {
          commit('logError', e)
        })
    }
  },
  fetchAllPIsAction ({ state, commit }) {
    if (!state.allPIs) {
      fetchAllPIs()
        .then(response => {
          commit('setAllPIs', response.data.pi)
        })
        .catch(e => {
          commit('logError', e)
        })
    }
  },
  fetchAllResourceTypesAction ({ state, commit }) {
    if (!state.allResourceTypes) {
      fetchAllResourceTypes()
        .then(response => {
          commit('setAllResourceTypes', response.data.resource_type)
        })
        .catch(e => {
          commit('logError', e)
        })
    }
  }
}

export default { state, actions, mutations }
